import axios from 'axios';

export const createDemoOrder = (newOrder) => {
  const { amountSummary } = newOrder;
  const fixedAmmountSummary = {};
  Object.keys(amountSummary).forEach((key) => {
    const originalObject = amountSummary[key];
    fixedAmmountSummary[key] = {
      ...originalObject,
      value: Number.parseFloat(originalObject.value),
    };
  });
  const normalizedOrder = {
    ...newOrder,
    amountSummary: fixedAmmountSummary,
  };

  return axios.post('/Demos', normalizedOrder);
};

export const deactivateDemoOrder = (storeId, demoData) => {
  return axios.post(`/Demos/deactivateDemoStore/${storeId}`, demoData);
};
